import { render, staticRenderFns } from "./ReportColumn.vue?vue&type=template&id=8aef5fdc&"
import script from "./ReportColumn.vue?vue&type=script&lang=js&"
export * from "./ReportColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8aef5fdc')) {
      api.createRecord('8aef5fdc', component.options)
    } else {
      api.reload('8aef5fdc', component.options)
    }
    module.hot.accept("./ReportColumn.vue?vue&type=template&id=8aef5fdc&", function () {
      api.rerender('8aef5fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportTable/ReportColumn.vue"
export default component.exports